import { render, staticRenderFns } from "./CreatePromoCodeView.vue?vue&type=template&id=4636fa52"
import script from "./CreatePromoCodeView.vue?vue&type=script&lang=js"
export * from "./CreatePromoCodeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports